import {SystemJournalCountersDto} from "../../api";

// Виды сбоев на странице «Сбои»; filter — фильтр раздела «Состояние системы» в журнале станции
export type FailureKindKey = "connection" | "power" | "restarts" | "faults" | "door" | "shock";

export type FailureKind = {
  key: FailureKindKey;
  label: string;
  short: string;
  tone: string;
  filter: string;
  count: (c: SystemJournalCountersDto) => number;
};

export const FAILURE_KINDS: FailureKind[] = [
  {key: "connection", label: "Связь", short: "связь", tone: "connection", filter: "connection", count: (c) => c.connectionLosses ?? 0},
  {key: "power", label: "Питание", short: "питание", tone: "power", filter: "power", count: (c) => c.powerEvents ?? 0},
  {key: "restarts", label: "Перезапуски", short: "перезапуск", tone: "restart", filter: "restarts", count: (c) => c.restarts ?? 0},
  {key: "faults", label: "Механизмы", short: "механизм", tone: "fault", filter: "faults", count: (c) => c.mechanismFaults ?? 0},
  {key: "door", label: "Дверь", short: "дверь", tone: "door", filter: "door", count: (c) => c.doorOpenings ?? 0},
  {key: "shock", label: "Удар", short: "удар", tone: "door", filter: "door", count: (c) => c.shocks ?? 0},
];

export const KIND_BY_EVENT: Record<string, FailureKindKey> = {
  Connection: "connection",
  Power: "power",
  Restart: "restarts",
  MechanismFault: "faults",
  Door: "door",
  Shock: "shock",
};
